import request from '@/utils/request'

export function getJsConfig(params) {
  return request({
    url: '/oa/get_js',
    method: 'get',
    params
  })
}

export function getRetUrl(params) {
  return request({
    url: '/oa/ret_url',
    method: 'get',
    params
  })
}


export function loginByAlipay(params) {
  return request({
    url: '/customer/loginbyali',
    method: 'get',
    params
  })
}

export function regInfo(data) {
  return request({
    url: '/customer/reginfo',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/customer/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/customer/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js